import { TitleMultiImageTextProps, ITitleMultiImageText, IItem } from './types';

export const mapTitleMultiImageText = ({
  prismicContent,
}: {
  prismicContent: TitleMultiImageTextProps['slice'];
}): ITitleMultiImageText => {
  const items: IItem[] = prismicContent.items.map((item) => {
    const {
      image: { url: image, alt },
    } = item;

    return {
      ...item,
      image: image as string, // TODO: https://lafourche.atlassian.net/browse/LF-3882 handle empty string in tsx
      alt: alt as string, // TODO: https://lafourche.atlassian.net/browse/LF-3882 handle empty string in tsx
    };
  });

  const titleMultiImageText: ITitleMultiImageText = {
    ...prismicContent.primary,
    items,
  };

  return titleMultiImageText;
};
